import React from 'react'
import { Helmet } from 'react-helmet'

import leakage_repair1 from '../../assets/services-image/leakage_repair1.jpg'
import leakage_repair2 from '../../assets/services-image/Carpentry-1.jpeg'

import leakage_repair3 from '../../assets/services-image/ceiling_partition1.jpg'

const LeakageRepair = () => {
  return (
    <><Helmet>
      <meta charSet="utf-8" />
      <title>Leakage Repair Services</title>
    </Helmet>
      <div className='bg-gray-300'>
         <section className="mx-5 md:container md:mx-auto py-10 ">
        <h2 className="text-3xl font-bold">Leakage Repair Services in Singapore</h2>
        <div className="flex my-5 gap-4">
          <img
            src={leakage_repair1}
            className="h-[300px] w-full md:w-1/2 lg:w-full"
            alt=""
          />
          <img
            src={leakage_repair2}
            className="h-[300px] w-full hidden md:block md:w-1/2 lg:w-full"
            alt=""
          />
          <img
            src={leakage_repair3}
            className="h-[300px] w-full hidden lg:block"
            alt=""
          />
        </div>
        <div className="flex flex-col gap-5">
          <p className="text-justify font-semibold">
            Building or renovating your precious house or office with modernized
            materials and designs carpentry gives the most artistic value on
            viewing sight. Various furnishing choice of carpentry can boost the
            interior and exterior outlook with elegances. Local Carpentry Work
            Services provide Leakage Repair service in Singapore in your local. In
            commercial or residential property most of the carpentry service in
            Singapore is done in a huge scale like renovations.
          </p>
          <p className="text-justify font-semibold">
            Singapore is the world class city and to renovating your home and
            office decor, your first thinking in mind is how to modernize look
            of your furnishers, therefore you must need expert Leakage Repair
            services in Singapore. You better looking for a home improvement
            expert Leakage Repair near your local in Singapore to furnish your
            dreaming household materials then local Carpentry Work Sg will provides
            you the likeminded best experienced Leakage Repair on your demand.
          </p>
          <h2 className="text-3xl font-bold">Leakage Repair Singapore Services list</h2>
          <p className="text-justify font-semibold">
            There are different and various types of Leakage Repair services are
            available in Singapore. Customize shelves or furniture, any display
            into a partition or mounting picture frame, alteration and repair of
            cabinet, doors, door frame and shelves or handrails, varnish woods
            etc. We are enlisted the most common Leakage Repair services list in the
            followings:
          </p>
          <p className="font-bold">
            Assemble (install) or Dismantle of the following
          </p>
          <ul className="list-disc">
            <li>Beds</li>
            <li>Chairs</li>
            <li>Furniture</li>
            <li>Shelves</li>
            <li>Table</li>
          </ul>
          <p className="font-bold">
            Supply (installation) or replacement of the following
          </p>
          <ul className="list-disc">
            <li>Cabinet doors below the sink</li>
            <li>Cabinet hinges</li>
            <li>Cabinet locks</li>
            <li>Cupboard/ cabinet track</li>
            <li>Doors</li>
            <li>Door frame</li>
            <li>Doorknobs</li>
            <li>Door locks</li>
            <li>Supporting brackets</li>
            <li>Vanity mirror</li>
            <li>Wardrobe support</li>
          </ul>
          <h2 className="text-3xl font-bold">Leakage Repair Singapore Services list</h2>
          <p className="text-justify font-semibold">
            There are several renowned Leakage Repair service companies available in
            Singapore and provides excellent Carpentry Work service. Local Carpentry Work Sg
            is the Leakage Repair service company, can design and fabricate pretty
            much anything that what is made of wood. From simple shelving units
            and custom made bedroom furniture to bespoke and made to measure
            bathroom and kitchen units. This Carpentry Work service company also
            provides –
          </p>
          <ul className="list-disc">
            <li>Bathroom vanity</li>
            <li>Built-in wardrobe</li>
            <li>Direct Leakage Repair</li>
            <li>Door repair/ replacement</li>
            <li>Feature wall</li>
            <li>Furniture repair</li>
            <li>Handle installations (Door, shelves, cabinets etc)</li>
            <li>Hinge installation & replacement</li>
            <li>Kitchen cabinet and carpentry</li>
            <li>Platform bed</li>
            <li>Shoe cabinet</li>
            <li>TV consoles</li>
            <li>Woodworking craft</li>
            <li>Wooden door repair & installation</li>
            <li>Varnishing furniture & furniture repairs</li>
          </ul>
          <h2 className="text-3xl font-bold">Furniture Assembly</h2>
          <p className="text-justify font-semibold">
            Carpentry is an art on home or office decorating and furnishing. You
            need furniture assembly then you must call the local Carpentry Work
            Leakage Repair service near your area for an expert interior and exterior
            performance works. Any types of carpentry works or furniture
            assembly local Carpentry Work Sg service always near beside your needs.
          </p>
          <ul className="list-disc">
            <li>Carpentry work</li>
            <li>Commercial services</li>
            <li>Contracting services</li>
            <li>Custom built in carpentry</li>
            <li>Furniture</li>
            <li>Interior design</li>
            <li>Refurbishing and reupholstery</li>
            <li>Renovation services</li>
            <li>Residential services</li>
            <li>Woodworking</li>
          </ul>
          <h2 className="text-3xl font-bold">General Carpentry Services</h2>
          <p className="text-justify font-semibold">
            Leakage Repairs can provide woodworking crafts, focusing on craftsmanship
            and the quality of their woodwork. So, general carpentry services
            are included in –
          </p>
          <ul className="list-disc">
            <li>Deck construction</li>
            <li>Deck repair</li>
            <li>Design and build</li>
            <li>Floor joist construction</li>
            <li>Framing</li>
            <li>Pool deck construction</li>
            <li>Residential and commercial interior design</li>
            <li>Structural rot removal and repairs</li>
            <li>Structural stair repair</li>
          </ul>
          <h2 className="text-3xl font-bold">Home Carpentry Services</h2>
          <p className="text-justify font-semibold">
            Kitchen carpentry is very common home carpentry services in
            Singapore. Wooden cabinets or custom made drawers are designed to
            have multiple compartments that give your home a rustic look.
          </p>
          <ul className="list-disc">
            <li>Bedroom Carpentry</li>
            <li>Built-In Wardrobes</li>
            <li>Countertop</li>
            <li>Door Replacement</li>
            <li>Feature Wall</li>
            <li>Kitchen Cabinets</li>
            <li>Kitchen Countertop</li>
            <li>Platform Bed</li>
            <li>Railing Installation</li>
            <li>Ramp Installation</li>
            <li>Rough Carpentry</li>
            <li>Shoe Cabinets</li>
            <li>Stair Framing</li>
            <li>Stairs and Railing</li>
          </ul>
        </div>
      </section></div>
    </>

  )
}

export default LeakageRepair